import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EditStockModuleContext from 'contexts/EditStockModuleContext';
import { getStockSupplier } from 'services/supplierServices';
import { StockSupplier } from 'types/models/StockReceipt';
import StockSupplierForm from 'forms/StockSupplierForm';

export default (): JSX.Element => {
  const { t } = useTranslation();
  const history = useHistory();
  const { selectedSupplier } = React.useContext(EditStockModuleContext);
  const [completeStockSupplier, setCompleteStockSupplier] = React.useState<StockSupplier | null>(null);

  React.useEffect(() => {
    if (!selectedSupplier) {
      history.replace('/private/stock/suppliers');
      return;
    }

    let mounted = true;

    (async () => {
      const completeData = await getStockSupplier(selectedSupplier.id);

      if (!mounted) return;

      if (!completeData) {
        history.replace('/private/stock/suppliers');
        return;
      }

      setCompleteStockSupplier(completeData);
    })();

    return () => {
      mounted = false;
    };
  }, [selectedSupplier, history]);

  if (!selectedSupplier) return <></>;
  if (!completeStockSupplier) return <div>{t('loading')}</div>;

  return <StockSupplierForm supplier={completeStockSupplier} />;
};
